import { useQuery } from "@tanstack/react-query";
import { api, keys, type Uuid } from "@shared/api";

/** Свои права в канале и чей это канал. */
export interface Access {
  permissions: number;
  serverId: Uuid | null;
}

/**
 * Права в канале.
 *
 * Одной функцией на всех, кто их спрашивает: открытый канал, канал звонка и
 * меню ветки из списка каналов спрашивают об одном ключе кэша. Разойдись у них
 * ответ по виду, второй молча переписал бы первому `serverId` в пустоту.
 */
export function rightsIn(channelId: Uuid): Promise<Access> {
  return api.permissions
    .onChannel(channelId)
    .then((value) => ({ permissions: value.permissions, serverId: value.server_id }))
    .catch(() => ({ permissions: 0, serverId: null }));
}

/** Права в канале как запрос: `null`, пока не пришли или канала нет. */
export function useChannelRights(channelId: Uuid | null): Access | null {
  const { data = null } = useQuery({
    queryKey: keys.channelRights(channelId!),
    enabled: !!channelId,
    queryFn: () => rightsIn(channelId!),
  });
  return data;
}
